<div
    class="w-full min-h-fit h-[calc(100vh-5rem)] flex flex-row justify-center items-stretch bg-zen-background px-12 lg:px-20 pb-6 pt-2">
    <div class="w-full h-fit max-w-[100rem] min-w-[48rem] flex flex-col items-stretch">
        <ng-content></ng-content>
    </div>
</div>